<template>
  <div class="main_div">
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1>사용자 상세</h1>
      </div>
      <div class="contents_wrap">
        <div class="small_title_wrap">
          <h2>사용자 정보</h2>
        </div>
        <ul class="filter_list">
          <li>
            <dd>
               <label>ID</label>
              <ul>
                <li>
                   {{ userInfo.userId }}
                </li>
              </ul>
            </dd>
            <dd>
            <label>성명</label>
            <ul>
              <li>
               {{ userInfo.userNm }}
              </li>
            </ul>
          </dd>
          </li>
          <li>
            <dd>
              <label>소속 회사</label>
              <ul>
                <li v-if="userInfo.cmpyNm !== undefined && userInfo.cmpyNm !== null && userInfo.cmpyNm !==''">
                  {{ userInfo.cmpyNm }}
                </li>
                <li v-else>
                  -
                </li>
              </ul>
            </dd>
            <dd>
              <label>권한</label>
              <ul>
                <li>
                  {{ userInfo.authNm }}
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>사업장/거점</label>
              <ul>
                <li v-if="userInfo.facilityNm === null && userInfo.areaNm === null">
                  -
                </li>
                <li v-else>
                  {{ userInfo.facilityNm }} / {{ userInfo.areaNm }}
                </li>
              </ul>
            </dd>
            <dd>
              <label>카드 No.</label>
              <ul>
                <li>
                  {{ !!userInfo.s1EmpNo ? userInfo.s1EmpNo : '-' }}
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>휴대전화번호</label>
              <ul>
                <li>
                  {{ userInfo.spTelNo }}
                </li>
              </ul>
            </dd>
            <dd>
              <label>이메일 주소</label>
              <ul>
                <li>
                  {{ userInfo.email }}
                </li>
              </ul>
            </dd>
            <li>
              <dd>
                <label>계정 상태</label>
                <ul>
                  <li>
                    {{ userInfo.useYn }}
                  </li>
                </ul>
              </dd>
              <dd>
                <label>IP 접근 제어 설정</label>
                <ul>
                  <li style="display:flex; align-items:flex-start; line-height:1.9; padding-top:6px;">
                    <span class="mr10" :class="userInfo.ipPolicyYn === 'Y' ? 'org' : ''">
                      {{ userInfo.ipPolicyYn }}
                    </span>
                    <span
                        v-if="userInfo.ipPolicyYn === 'Y' && userInfo.allowIpList && userInfo.allowIpList.length > 0"
                        class="ip-grid">
                      <template v-for="(item, idx) in userInfo.allowIpList">
                        <span :key="'ip' + idx" class="ip-addr">{{ item.ipAddress }}/{{ item.cidrPrefix }}</span>
                        <span :key="'dt' + idx" class="ip-date">{{ item.lastMdfyDt }}</span>
                      </template>
                    </span>
                  </li>
                </ul>
              </dd>
            </li>
        </ul>
      </div>
       <div class="button_area w100">
         <ul>
           <li v-show="isSU && userInfo.useYn!=='탈퇴'" class="w10"><button class="large_btn orange" @click="onClickUpdateUser">수정</button></li>
           <li class="w10"><button class="large_btn" @click="onClickList">목록</button></li>
         </ul>
       </div>
    </section>
  </div>
</template>

<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import EtnersParseUtil from '@/common/etners.parse.util'
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: 'UserDetail',
  mounted () {
    const vm = this
    vm.getUserDetail()
  },
  methods: {
    getUserDetail () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/user/getUserDetail.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        unqUserNo: vm.unqUserNo
      }

      ApiUtil.post(url, param).then(response => {
        if(response.data === undefined || response.data.resultStatus === undefined){
          kendo.alert('정상적으로 처리되지 않았습니다.')
          return false
        }

        if (response.data.resultStatus.messageCode !== '2000') {
          if (response.data.resultStatus.messageCode === '4002') {
            kendo.alert(response.data.resultStatus.messageText)
            vm.$router.go(-1)
          } else {
            kendo.alert(response.data.resultStatus.messageText)
            return false
          }
        }
        let resultData = response.data.resultData
        if (EtnersCommonUtil.isNotEmpty(resultData) && EtnersCommonUtil.isNotEmpty(resultData.spTelNo)) {
          resultData.spTelNo = EtnersParseUtil.convertTelNo(resultData.spTelNo)
        }
        vm.userInfo = resultData
      })
    },

    onClickUpdateUser () {
      const vm = this
      vm.$router.push({
        name: 'UserUpdate',
        params: {
          unqUserNo: vm.unqUserNo
        }
      })
    },

    onClickList () {
      const vm = this
      vm.$router.push({
        name: 'UserList'
      })
    },
  },
  data: function() {
    const vm = this
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }

    const loginUserData = sessionStorage.getItem('loginUserData')
    let loginUserObj = JSON.parse(loginUserData)
    const isEtners = (loginUserObj.authId === '9999') || (loginUserObj.authId === '1001') ? true : false
    const isSU = loginUserObj.authId === '9999'

    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      isEtners: isEtners,
      isSU: isSU,
      unqUserNo: this.$route.params.unqUserNo,
      userInfo: {},
    }
  }
}
</script>

<style scoped>
.ip-grid {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 14px;
  row-gap: 2px;
}
.ip-date {
  color: #adb5bd;
}
</style>

